import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { HTTPError, post } from "common/helpers/HTTP";
import type { ProfileSearchParams } from "common/types";

async function pasteUrlTargetingRequest(
  workspaceId: string,
  accountId: string,
  url: string,
): Promise<Partial<ProfileSearchParams>> {
  return (
    await post(`workspaces/${workspaceId}/accounts/${accountId}/search/url`, {
      url,
    })
  ).result;
}

export default function usePasteUrlTargeting() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const {
    mutateAsync: getSearchParamsFromUrl,
    isPending: isGettingSearchParamsFromUrl,
  } = useMutation({
    mutationFn: ({ url, accountId }: { url: string; accountId: string }) =>
      pasteUrlTargetingRequest(workspaceId, accountId, url),
    onSuccess: () => toast.success("Targeting updated"),
    onError: (error) => {
      if (
        error instanceof HTTPError &&
        error.serverMessage === "InvalidUrlFormat"
      ) {
        toast.error("Invalid URL format. Please check the URL and try again.");
      } else {
        toast.error("Error getting targeting from URL");
      }
    },
  });

  return { getSearchParamsFromUrl, isGettingSearchParamsFromUrl };
}
